<template>
    <div :class="{'page-wrapper': themeName !== 'GolfCart'}" id="golf_cart_not_visible">
        <router-view />
        <Toast :breakpoints="{'920px': {width: '100%', right: '0', left: '0'}}" />
        <DialogsWrapper />
    </div>
</template>

<script>
    import MyLayout from '@/layout/layout.vue'
    import AuthUserServices from './Services/AuthUserServices.js';

    export default {
        components: {
            MyLayout
        },
        data() {


            return {
                themeName: '',

            }
        },
        mounted() {
            this.GetDynamicContent();
        },
        created() {
            this.GetDynamicContent();
            // this.ChangeFavIcon();
            localStorage.removeItem('initialLandingPage');
            if (!localStorage.getItem("initialLandingPage")) {
                localStorage.setItem("initialLandingPage", window.location.href);
            }
            this.themeName = localStorage.getItem('theme');



            setTimeout(function () {
                if (this.themeName == 'GolfCart') {
                    var getId = document.getElementById("golf_cart_not_visible")
                    if (getId != null) {
                        getId.classList.remove("page-wrapper");
                    }

                    this.addGoogleTagManager();

                    this.addGoogleTagManagerNoscript();
                }
            }, 4000);
        },
        methods: {
            async addGoogleTagManager() {
                // Create a script tag for GTM
                const script = document.createElement('script');
                script.innerHTML = `(function(w,d,s,l,i){
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-NZ9ZFWFS');`;

                document.head.appendChild(script);

                // Optionally, add a noscript fallback for users who have JavaScript disabled
                const noscript = document.createElement('noscript');
                noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NZ9ZFWFS" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                document.body.appendChild(noscript);
            },
            async addGoogleTagManagerNoscript() {
                const noscript = document.createElement('noscript');
                noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NZ9ZFWFS" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
                document.body.appendChild(noscript);
            },
            async GetDynamicContent() {
                debugger
               await AuthUserServices.GetDynamicContentForComapny(localStorage.getItem("companyId"), localStorage.getItem("userId"), localStorage.getItem("LanguageId")).then(res => {
                    const favicon = document.getElementById("favicon");
                    favicon.href = res.data.favIconLink;
                })
            },
        }

    }
</script>

<style>
</style>
